import "core-js/modules/es.array.find-index";
import "core-js/modules/es.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { format } from '@tencent/vft-common/date';
import config from '@/config';
import CommonTitle from '../common/CommonTitle/CommonTitle.vue';
export default {
  props: {
    num: {
      type: Number,
      default: 5
    }
  },
  components: {
    CommonTitle: CommonTitle
  },
  computed: {
    actList: function actList() {
      return window.setting.活动时刻.活动列表 || [];
    },
    now: function now() {
      return this.$store.state.now;
    },
    targetIndex: function targetIndex() {
      var _this = this;

      var index = this.actList.findIndex(function (item) {
        return _this.getActState(item) === 1;
      });

      if (index === -1) {
        index = this.actList.length - 1;
      }

      return index;
    }
  },
  watch: {
    actList: function actList() {
      this.init();
    }
  },
  methods: {
    // eslint-disable-next-line no-underscore-dangle
    _openUrl: function _openUrl(item) {
      if (item.跳转链接) {
        this.openUrl(item.跳转链接);
        return;
      }

      if (item.点击提示) {
        this.toast(item.点击提示);
      }
    },
    init: function init() {
      var el = this.$refs.actList;
      var itemWidth = 142 * config.rem / 37.5;
      el.scrollLeft = itemWidth;
    },
    getActState: function getActState(act) {
      if (act.是否进行中) {
        return 1;
      }

      if (this.now > act.活动结束时间) {
        return 0;
      }

      if (this.now >= act.活动时间 && this.now <= act.活动结束时间) {
        return 1;
      }

      return 2;
    },
    getActBadge: function getActBadge(act) {
      var state = this.getActState(act);
      var map = {
        0: '已结束',
        1: '火热进行中',
        2: '未开始'
      };
      return act.活动角标 || map[state];
    },
    formatTime: function formatTime(time) {
      if (typeof time === 'number') {
        return format(new Date(time), 'Y-mm-dd');
      }

      return time;
    }
  },
  mounted: function mounted() {
    this.init();
  }
};